import _isNumber from 'lodash/isNumber';
import Parameter, { BoolClause } from './Parameter';
import ParameterKeyValue from './ParameterKeyValue';

const DEFAULT_PAGE_SIZE = 200;

export default class PageSizeFilter extends Parameter {
  private _pageSize: number;

  constructor(pageSize: number) {
    super();
    this._pageSize =
      !_isNumber(pageSize) || !(pageSize > 0) ? DEFAULT_PAGE_SIZE : pageSize;
  }

  get parameterKeyValue(): ParameterKeyValue {
    return new ParameterKeyValue('pageSize', this._pageSize);
  }

  async getFSSClause(): Promise<BoolClause | null> {
    return null; // page size not handled in where clause
  }
}
